import {
    USUARIO_MODO_TELA,
    USUARIO_SET_AGUARDANDO,
    USUARIO_LISTADO
} from './usuarioActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case USUARIO_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case USUARIO_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case USUARIO_LISTADO: {
            const lista = action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };
        }

        default:
            return state;
    }
};